import {Component} from "@angular/core";


@Component({
  templateUrl: './facturation-client-panel.component.html',
  styleUrls: ['./facturation-client-panel.component.scss'],
  standalone: false
})
export class FacturationClientPanelComponent {

  currentIndex = 0;
}
